import { Box, styled } from '@mui/material';

export const GradientContainer = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'isOnboardingAdvancedSteps',
})(({ theme, isOnboardingAdvancedSteps }) => ({
  backgroundBlendMode: 'multiply',
  backgroundImage:
    'linear-gradient(to bottom, rgba(49, 49, 49, 0) 10%, #000 111%)',
  position: 'absolute',
  bottom: 0,
  width: '100%',
  display: isOnboardingAdvancedSteps ? 'none' : 'flex',
  justifyContent: 'center',
  paddingTop: '157px',

  [theme.breakpoints.up('xxxxl')]: {
    backgroundImage: 'linear-gradient(to bottom, rgba(49, 49, 49, 0), #000)',
  },
}));

export const TextContainer = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'isFormPage',
})(({ theme, isFormPage }) => ({
  width: isFormPage ? '448px' : '896px',
  margin: isFormPage ? '0 0 124px' : '0 0 48px',
  [theme.breakpoints.up('xxl')]: {
    width: isFormPage ? '656px' : '1184px',
    margin: !isFormPage && '0 0 80px',
  },
  [theme.breakpoints.up('xxxxl')]: {
    width: !isFormPage && '1408px',
    margin: !isFormPage && '0 0 48px',
  },
}));
